import React from 'react'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import FormRow from '../../../components/FormRow'
import CustomerCopilotSettingsModal from './CustomerCopilotSettingsModal'
import useCustomerCopilotSettings from './useCustomerCopilotSettings'

interface CustomerCopilotSettingsActionProps {
  customerId: string
  copilotEnabled: boolean
  onSaved: (copilotEnabled: boolean) => void
}

function CustomerCopilotSettingsAction(props: Readonly<CustomerCopilotSettingsActionProps>) {
  const { customerId, copilotEnabled, onSaved } = props
  const { t } = useTranslation()

  const settings = useCustomerCopilotSettings({ customerId, copilotEnabled, onSaved })

  return (
    <FormRow title={t('customers.copilotSettings')}>
      <div className="form-row-special-input">
        <Button
          type="button"
          onClick={settings.open}
          data-testid="copilot-settings-open"
        >
          <span>{t('customers.copilotSettings')}</span>
        </Button>
      </div>

      {settings.isOpen && (
        <CustomerCopilotSettingsModal
          status={settings.status}
          errorKey={settings.errorKey}
          showNoKeyInstalled={settings.showNoKeyInstalled}
          copilotEnabled={settings.copilotEnabled}
          copilotApiToken={settings.copilotApiToken}
          onCopilotEnabledChange={settings.setCopilotEnabled}
          onCopilotApiTokenChange={settings.setCopilotApiToken}
          onSave={settings.save}
          onClose={settings.close}
        />
      )}
    </FormRow>
  )
}

export default CustomerCopilotSettingsAction
